"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    compoundButtonClassNames: function() {
        return compoundButtonClassNames;
    },
    useCompoundButtonStyles_unstable: function() {
        return useCompoundButtonStyles_unstable;
    }
});
const _react = require("@griffel/react");
const _useButtonStylesstyles = require("../Button/useButtonStyles.styles");
const compoundButtonClassNames = {
    root: 'fui-CompoundButton',
    icon: 'fui-CompoundButton__icon',
    contentContainer: 'fui-CompoundButton__contentContainer',
    secondaryContent: 'fui-CompoundButton__secondaryContent'
};
const useRootStyles = /*#__PURE__*/ (0, _react.__styles)({
    base: {
        Bqenvij: "f11ysow2",
        J657lq: "f1um431h",
        Jlnjib: "fte7hqw",
        Bc29nj9: "f1yh8ef3"
    },
    highContrast: {
        pu7qz5: "fi3u9nm",
        B10010i: "f1tdgb9w"
    },
    outline: {},
    primary: {
        J657lq: "foe7gw6",
        Jlnjib: "fvxlz81",
        Bc29nj9: "f1c2mdy",
        B8ia98v: "f1r39r2s"
    },
    secondary: {},
    subtle: {
        J657lq: "f1um431h",
        Jlnjib: "fte7hqw",
        Bc29nj9: "f1yh8ef3",
        pu7qz5: "f1xoeh18",
        B10010i: "f1ca1nd7"
    },
    transparent: {
        J657lq: "f1um431h",
        Jlnjib: "f1wn9xqz",
        Bc29nj9: "f1a8q4d0"
    },
    small: {
        z8tnut: "f17mpqex",
        z189sj: [
            "f1vdfbxk",
            "f1f5gg8d"
        ],
        Byoj8tv: "f1quwm26",
        uwmqm3: [
            "f1f5gg8d",
            "f1vdfbxk"
        ],
        Be2twd7: "fkhj508",
        Bg96gwp: "f1i3iumi"
    },
    medium: {
        z8tnut: "fbtff6s",
        z189sj: [
            "fw5db7e",
            "f1uw59to"
        ],
        Byoj8tv: "flw3t2g",
        uwmqm3: [
            "f1uw59to",
            "fw5db7e"
        ],
        Be2twd7: "fkhj508",
        Bg96gwp: "f1i3iumi"
    },
    large: {
        z8tnut: "fm4bm3s",
        z189sj: [
            "fjodcmx",
            "fhx4nu"
        ],
        Byoj8tv: "fdt8xvx",
        uwmqm3: [
            "fhx4nu",
            "fjodcmx"
        ],
        Be2twd7: "fod5ikn",
        Bg96gwp: "faaz57k"
    },
    disabled: {
        J657lq: "f1rlv8bf",
        Jlnjib: "fd1dbtm",
        Bc29nj9: "f1vqmdmi"
    },
    disabledHighContrast: {
        B8ia98v: "f1csacz4",
        pu7qz5: "f1s5tkfe",
        B10010i: "fs0rda3"
    }
}, {
    d: [
        ".f11ysow2{height:auto;}",
        ".f1um431h .fui-CompoundButton__secondaryContent{color:var(--colorNeutralForeground2);}",
        ".foe7gw6 .fui-CompoundButton__secondaryContent{color:var(--colorNeutralForegroundOnBrand);}",
        ".f17mpqex{padding-top:var(--spacingHorizontalS);}",
        ".f1vdfbxk{padding-right:var(--spacingHorizontalS);}",
        ".f1f5gg8d{padding-left:var(--spacingHorizontalS);}",
        ".f1quwm26{padding-bottom:var(--spacingHorizontalMNudge);}",
        ".fkhj508{font-size:var(--fontSizeBase300);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}",
        ".fbtff6s{padding-top:14px;}",
        ".fw5db7e{padding-right:var(--spacingHorizontalM);}",
        ".f1uw59to{padding-left:var(--spacingHorizontalM);}",
        ".flw3t2g{padding-bottom:var(--spacingHorizontalL);}",
        ".fm4bm3s{padding-top:18px;}",
        ".fjodcmx{padding-right:var(--spacingHorizontalL);}",
        ".fhx4nu{padding-left:var(--spacingHorizontalL);}",
        ".fdt8xvx{padding-bottom:var(--spacingHorizontalXL);}",
        ".fod5ikn{font-size:var(--fontSizeBase400);}",
        ".faaz57k{line-height:var(--lineHeightBase400);}",
        ".f1rlv8bf .fui-CompoundButton__secondaryContent{color:var(--colorNeutralForegroundDisabled);}"
    ],
    h: [
        ".fte7hqw:hover .fui-CompoundButton__secondaryContent{color:var(--colorNeutralForeground2Hover);}",
        ".f1yh8ef3:hover:active .fui-CompoundButton__secondaryContent{color:var(--colorNeutralForeground2Pressed);}",
        ".fvxlz81:hover .fui-CompoundButton__secondaryContent{color:var(--colorNeutralForegroundOnBrand);}",
        ".f1c2mdy:hover:active .fui-CompoundButton__secondaryContent{color:var(--colorNeutralForegroundOnBrand);}",
        ".f1wn9xqz:hover .fui-CompoundButton__secondaryContent{color:var(--colorNeutralForeground2BrandHover);}",
        ".f1a8q4d0:hover:active .fui-CompoundButton__secondaryContent{color:var(--colorNeutralForeground2BrandPressed);}",
        ".fd1dbtm:hover .fui-CompoundButton__secondaryContent{color:var(--colorNeutralForegroundDisabled);}",
        ".f1vqmdmi:hover:active .fui-CompoundButton__secondaryContent{color:var(--colorNeutralForegroundDisabled);}"
    ],
    m: [
        [
            "@media (forced-colors: active){.fi3u9nm:hover .fui-CompoundButton__secondaryContent{color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1tdgb9w:hover:active .fui-CompoundButton__secondaryContent{color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1r39r2s .fui-CompoundButton__secondaryContent{color:HighlightText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1xoeh18:hover .fui-CompoundButton__secondaryContent{color:Canvas;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1ca1nd7:hover:active .fui-CompoundButton__secondaryContent{color:Canvas;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1csacz4 .fui-CompoundButton__secondaryContent{color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1s5tkfe:hover .fui-CompoundButton__secondaryContent{color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fs0rda3:hover:active .fui-CompoundButton__secondaryContent{color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ]
});
const useRootIconOnlyStyles = /*#__PURE__*/ (0, _react.__styles)({
    small: {
        z8tnut: "f1x4af0m",
        z189sj: [
            "f7x41pl",
            "fruq291"
        ],
        Byoj8tv: "fd55psn",
        uwmqm3: [
            "fruq291",
            "f7x41pl"
        ],
        B2u0y6b: "ft5vyj6",
        Bf4jedk: "f17suaiq"
    },
    medium: {
        z8tnut: "f16k8034",
        z189sj: [
            "fdw0yi8",
            "fk8j09s"
        ],
        Byoj8tv: "f1angvds",
        uwmqm3: [
            "fk8j09s",
            "fdw0yi8"
        ],
        B2u0y6b: "fdczgix",
        Bf4jedk: "fjdcg9m"
    },
    large: {
        z8tnut: "f17mpqex",
        z189sj: [
            "f1vdfbxk",
            "f1f5gg8d"
        ],
        Byoj8tv: "fdvome7",
        uwmqm3: [
            "f1f5gg8d",
            "f1vdfbxk"
        ],
        B2u0y6b: "fww51uw",
        Bf4jedk: "f1qhsl2h"
    }
}, {
    d: [
        ".f1x4af0m{padding-top:var(--spacingHorizontalXS);}",
        ".f7x41pl{padding-right:var(--spacingHorizontalXS);}",
        ".fruq291{padding-left:var(--spacingHorizontalXS);}",
        ".fd55psn{padding-bottom:var(--spacingHorizontalXS);}",
        ".ft5vyj6{max-width:48px;}",
        ".f17suaiq{min-width:48px;}",
        ".f16k8034{padding-top:var(--spacingHorizontalSNudge);}",
        ".fdw0yi8{padding-right:var(--spacingHorizontalSNudge);}",
        ".fk8j09s{padding-left:var(--spacingHorizontalSNudge);}",
        ".f1angvds{padding-bottom:var(--spacingHorizontalSNudge);}",
        ".fdczgix{max-width:52px;}",
        ".fjdcg9m{min-width:52px;}",
        ".f17mpqex{padding-top:var(--spacingHorizontalS);}",
        ".f1vdfbxk{padding-right:var(--spacingHorizontalS);}",
        ".f1f5gg8d{padding-left:var(--spacingHorizontalS);}",
        ".fdvome7{padding-bottom:var(--spacingHorizontalS);}",
        ".fww51uw{max-width:56px;}",
        ".f1qhsl2h{min-width:56px;}"
    ]
});
const useIconStyles = /*#__PURE__*/ (0, _react.__styles)({
    base: {
        Be2twd7: "fndrnj9",
        Bqenvij: "fbhnoac",
        a9b677: "feqmc2u"
    },
    before: {
        t21cq0: [
            "fkujibs",
            "f199hnxi"
        ]
    },
    after: {
        Frg6f3: [
            "f199hnxi",
            "fkujibs"
        ]
    }
}, {
    d: [
        ".fndrnj9{font-size:40px;}",
        ".fbhnoac{height:40px;}",
        ".feqmc2u{width:40px;}",
        ".fkujibs{margin-right:var(--spacingHorizontalM);}",
        ".f199hnxi{margin-left:var(--spacingHorizontalM);}"
    ]
});
const useContentContainerStyles = /*#__PURE__*/ (0, _react.__styles)({
    base: {
        mc9l5x: "f22iagw",
        Beiy3e4: "f1vx9l62",
        fsow6f: [
            "f1o700av",
            "fes3tcz"
        ]
    }
}, {
    d: [
        ".f22iagw{display:flex;}",
        ".f1vx9l62{flex-direction:column;}",
        ".f1o700av{text-align:left;}",
        ".fes3tcz{text-align:right;}"
    ]
});
const useSecondaryContentStyles = /*#__PURE__*/ (0, _react.__styles)({
    base: {
        Bg96gwp: "flkuc6h",
        Bhrd7zp: "figsok6"
    },
    small: {
        Be2twd7: "fy9rknc"
    },
    medium: {
        Be2twd7: "fy9rknc"
    },
    large: {
        Be2twd7: "fkhj508"
    }
}, {
    d: [
        ".flkuc6h{line-height:100%;}",
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        ".fy9rknc{font-size:var(--fontSizeBase200);}",
        ".fkhj508{font-size:var(--fontSizeBase300);}"
    ]
});
const useCompoundButtonStyles_unstable = (state)=>{
    const rootStyles = useRootStyles();
    const rootIconOnlyStyles = useRootIconOnlyStyles();
    const iconStyles = useIconStyles();
    const contentContainerStyles = useContentContainerStyles();
    const secondaryContentStyles = useSecondaryContentStyles();
    const { appearance, disabled, disabledFocusable, iconOnly, iconPosition, size } = state;
    state.root.className = (0, _react.mergeClasses)(compoundButtonClassNames.root, // Root styles
    rootStyles.base, rootStyles.highContrast, appearance && rootStyles[appearance], rootStyles[size], // Disabled styles
    (disabled || disabledFocusable) && rootStyles.disabled, (disabled || disabledFocusable) && rootStyles.disabledHighContrast, // Icon-only styles
    iconOnly && rootIconOnlyStyles[size], // User provided class name
    state.root.className);
    state.contentContainer.className = (0, _react.mergeClasses)(compoundButtonClassNames.contentContainer, contentContainerStyles.base, state.contentContainer.className);
    if (state.icon) {
        state.icon.className = (0, _react.mergeClasses)(compoundButtonClassNames.icon, iconStyles.base, state.root.children !== undefined && state.root.children !== null && iconStyles[iconPosition], state.icon.className);
    }
    if (state.secondaryContent) {
        state.secondaryContent.className = (0, _react.mergeClasses)(compoundButtonClassNames.secondaryContent, secondaryContentStyles.base, secondaryContentStyles[size], state.secondaryContent.className);
    }
    (0, _useButtonStylesstyles.useButtonStyles_unstable)(state);
    return state;
}; //# sourceMappingURL=useCompoundButtonStyles.styles.js.map
